import { render, staticRenderFns } from "./MovimientosTabContent.vue?vue&type=template&id=935a972c"
import script from "./MovimientosTabContent.vue?vue&type=script&lang=js"
export * from "./MovimientosTabContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports